import { useHistory } from 'react-router-dom';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';
import { useForm } from '../forms/useForm';
import 'moment/locale/es';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import { ConfigServer } from "../../data/config";
import Chart from 'chart.js/auto'; 

export const useMicrositeClient = () => {

    const [loading, setLoading] = useState(false); 

    const { nim, password } = useParams();
    const [createSweet] = useSweetAlert();
    const [loadingForm, setLoadingForm] = useState(false);
    const [histories, setHistories] = useState([]);
    const history = useHistory();
    const [loadingNim, setLoadingNim] = useState(null);
    const [selectedStudy, setSelectedStudy] = useState("");
    const [currentAnalyteId, setCurrentAnalyteId] = useState(null);
    const [currentPatientNim, setCurrentPatientNim] = useState(null);
    const [workOrderPrintResultCaptureView, setWorkOrderPrintResultCaptureView] = useState({});
    const [lista, setLista] = useState({});
    const [listaExamenes, setListaExamenes] = useState([]);
    const [listaProfiles, setListaProfiles] = useState([]);
    const [idd, setIdd] = useState(0)
    const [chartOptions, setChartOptions] = useState({});
    const [chartDialogVisible, setChartDialogVisible] = useState(false);
    const [chartData, setChartData] = useState({ labels: [], datasets: [] });
    const [chartOptionsState, setChartOptionsState] = useState({});
    const [urlHelenLis, setUrlHelenLis] = useState('');

    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        input_nim: "",
        input_password: ""
    });

    const { input_nim, input_password } = formValues;


    useEffect(() => {
        if (password === undefined && nim === undefined) {
            handleUpdateValues({
                input_nim: "",
                input_password: ""
            })
        } else if (password !== "-" && nim !== "-") {
            handleUpdateValues({
                input_nim: nim,
                input_password: password
            })
        }

    }, []);

    //#endregion Login Microsite

    //#region State Result Nim


    //#endregion State Result Nim

    //#region Result From Nim
    const validateData = async (e) => {
        setLoadingForm(true);

        e.preventDefault();
        let requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };

        const respuesta = await sendRequest(requestOptions, `PrintResult/GetResultFromNimAndPassword/${input_nim}/${input_password}`);
        //console.log(respuesta);

        if (respuesta.code === 200) {
            let idP = []

            let idPacien = 0;
            setHistories(respuesta.data.histories);
            setWorkOrderPrintResultCaptureView(respuesta.data.workOrderPrintResultCaptureView);
            setUrlHelenLis(respuesta.data.workOrderPrintResultCaptureView.url_helen);
            setLista(respuesta.data.lista);
            setListaExamenes(respuesta.data.lista_examenes);
            setListaProfiles(respuesta.data.lista)
            setViewData(true);
            idPacien = respuesta.data.workOrderPrintResultCaptureView.id_patient;
            setIdd(idPacien)
            //  stattus = respuesta.data.workOrderPrintResultCaptureView.arrayStatus;

            respuesta.data.lista_examenes.forEach(element => {
                element.listAnalytes.forEach(obj => {
                    idP = obj.id_analyte
                });
            });
            // chartCaptureresul(idP, idPacien)
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, validateData);

        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Resultados", "Ocurrio un error en el servidor");
        }
        else {
            if (respuesta.code === 404) {
                createSweet("error", "warning", "NIM incorrecto");

                handleUpdateValues({
                    input_nim: "",
                    input_password: "",
                });
                setLoadingForm(false);


            }
            else {
                createSweet("error", "warning", "Resultados", respuesta.data.msg);

                handleUpdateValues({
                    input_nim: "",
                    input_password: "",
                });
                setLoadingForm(false);

            }
        }
    }

    //#endregion Result Nim

    //#region Chart
    const loadChartData = async (patientId, analyteId) => {
        let requestOptions = { method: 'GET' };
        const response = await sendRequest(requestOptions, `Exam/ChartAnalytePatientMicrosite/${patientId}/${analyteId}`);

        if (response.code === 200) {
            const data = response.data;

            const labels = data.values.map(v => v.date);
            const values = data.values.map(v => parseFloat(v.value));

            const minLine = Array(labels.length).fill(data.min);
            const maxLine = Array(labels.length).fill(data.max);

            let adjustedLabels = [...labels];
            let adjustedValues = [...values];
            let adjustedMinLine = [...minLine];
            let adjustedMaxLine = [...maxLine];
            
            if (values.length === 1) {
                adjustedLabels = ["", labels[0], ""];
                adjustedValues = [null, values[0], null]; 
                adjustedMinLine = [data.min, data.min, data.min];
                adjustedMaxLine = [data.max, data.max, data.max];
            }


            setChartData({
                labels: adjustedLabels,
                datasets: [
                    {
                        label: data.exam_name,
                        data: adjustedValues,
                        borderColor: '#0079C7',
                        borderWidth: 2,
                        tension: 0.4,
                        fill: false,
                        pointRadius: values.length === 1 ? 6 : 3,
                        pointBackgroundColor: values.length === 1 ? '#0079C7' : undefined
                    },
                    {
                        label: "Mínimo",
                        data: adjustedMinLine,
                        borderColor: '#f18c8cff',
                        borderWidth: 2,
                        pointRadius: 0,
                        fill: false,
                        tension: 0,
                        borderDash: [5, 5] 
                    },
                    {
                        label: "Máximo",
                        data: adjustedMaxLine,
                        borderColor: '#f18c8cff',
                        borderWidth: 2,
                        pointRadius: 0,
                        fill: false,
                        tension: 0,
                        borderDash: [5, 5] 
                    }
                ]
            });

        
          const minMaxLabelPlugin = {
            id: 'minMaxLabelPlugin',
            afterDraw: (chart) => {
                const { ctx, chartArea: { left, right }, scales: { y } } = chart;
                if (!y) return;

                const minDataset = chart.data.datasets.find(d => d.label === "Mínimo");
                const maxDataset = chart.data.datasets.find(d => d.label === "Máximo");
                if (!minDataset || !maxDataset) return;

                const minY = y.getPixelForValue(minDataset.data[0]);
                const maxY = y.getPixelForValue(maxDataset.data[0]);

                const isMobile = window.innerWidth < 768;

                ctx.save();
                ctx.font = 'bold 12px sans-serif';
                ctx.fillStyle = '#727272ff';

                if (isMobile) {
                    ctx.textAlign = 'left';
                    ctx.textBaseline = 'middle';
                    ctx.fillText('Max', right + 10, maxY);
                    ctx.fillText('Min', right + 10, minY);
                } else {
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'top';
                    ctx.fillText('Max', (left + right) / 2, maxY + 4);
                    ctx.fillText('Min', (left + right) / 2, minY + 4);
                }

                ctx.restore();
            }
        };


            Chart.register(minMaxLabelPlugin);
            const pointValuePlugin = {
            id: 'pointValuePlugin',
            afterDatasetsDraw: (chart) => {
                const { ctx, data, scales: { x, y } } = chart;

                ctx.save();
                ctx.font = 'bold 12px sans-serif';
                ctx.fillStyle = '#062a42ff';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'bottom';
                data.datasets[0].data.forEach((value, index) => {
                    if (value !== null) {
                        const xPos = x.getPixelForValue(index);
                        const yPos = y.getPixelForValue(value);
                        ctx.fillText(value.toFixed(1), xPos, yPos - 9); 
                    }
                });

                ctx.restore();
            }
        };

        Chart.register(pointValuePlugin);

        setChartOptions({
             devicePixelRatio: 3,
                plugins: {
                    legend: { display: true, position: 'top' },
                    tooltip: { enabled: true }
                },
                scales: {
                    x: {
                        title: { display: true, text: 'Fecha' },
                        ticks: {
                            maxRotation: 0,
                            minRotation: 0,
                            color: '#333'
                        },
                        grid: { display: values.length !== 1 }
                    },
                    y: {
                        title: { display: true, text: 'Valor' },
                        beginAtZero: false,
                        grace: '10%'
                    }
                },
                animation: false,
                elements: { line: { tension: 0.4 } }
            });

            setChartDialogVisible(true);
        }
    };

    //#endregion Chart

    //#region Dowload Result

    const downloadSheetResults = async (e, nim_local = "") => {
        const isHistorial = nim_local.length > 0;

        if (!isHistorial) {
            setLoading(true); 
        }

        setLoadingNim(nim_local);

          let body = {
            nim: input_nim,
            password: input_password,
            type: "",
            microsite: true,
        }
        if (nim_local.length > 0) {
            body.nim = nim_local;
            body.type = "NP";
        }

        let token = localStorage.getItem("token");

        await fetch(ConfigServer.serverUrl + "/api/PrintResult/DownloadSheetResultsPatient", {
            method: 'POST',
            body: JSON.stringify(body),
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
            .then(response => response.blob())
            .then(blob => {
                var url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Resultados.pdf");
                document.body.appendChild(link);
                link.style.display = 'none';
                link.click();
            });

        if (!isHistorial) {
            setLoading(false); 
        }
        setLoadingNim(null);
    }

    const [viewData, setViewData] = useState(false);

    const reload = () => {
        window.location.reload(true);
    }


    //#endregion DowLoad Resul

    //#region Profiles
    let profiles = Object.values(listaProfiles)

    let profilesHistories = Object.values(histories)

    //#endregion Profiles


    //#region historial Patient

    const [historialCollapse, setHistorialCollapse] = useState(false);

    //#endregion historial patient

    const [openProfiles, setOpenProfiles] = useState({});

    const toggleCollapse = (key) => {
        setOpenProfiles((prevState) => ({
            ...prevState,
            [key]: !prevState[key]
        }));
    };

    const [openExams, setOpenExams] = useState({});

    const toggleExamCollapse = (index) => {
        setOpenExams((prev) => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const [showPassword, setShowPassword] = useState(false);

    const toggleShowPassword = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };



    // #region TAB
    const [activeIndex, setActiveIndex] = useState(0);

    const items = [
        {
            label: 'Mi Información',
            command: () => setActiveIndex(0),
        },
        {
            label: 'Historial de Resultados',
            command: () => setActiveIndex(1),
        },
    ];

        const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "10px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "10px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    ////////////////////////////////////////////
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedData, setSelectedData] = useState([]);

    const combinedOptions = [
        ...Object.values(lista).map((item) => ({
        type: "perfil",
        id: item.id_profile,
        name: item.name,
        data: item.individualExams || [],
        })),
        ...listaExamenes.map((exam) => ({
        type: "examen",
        id: exam.id_exam,
        name: exam.name,
        data: [exam],
        })),
    ];
    // const handleSelectChange = (e) => {
    //     const selectedId = e.target.value;
    //     const option = combinedOptions.find((opt) => String(opt.id) === selectedId);
    //     setSelectedOption(option);

    //     if (option) {
    //         let analytes = [];
    //         const seenAnalytes = new Set(); 

    //         option.data.forEach((exam) => {
    //             if (exam.listAnalytes) {
    //                 const nim = input_nim;
    //                 exam.listAnalytes.forEach((a) => {
                        
    //                     if (a.result !== null && a.result !== undefined && !seenAnalytes.has(a.id_analyte)) {
    //                         analytes.push({ ...a, nim });
    //                         seenAnalytes.add(a.id_analyte);
    //                     }
    //                 });
    //             }
    //         });

    //         setSelectedData(analytes);
    //     } else {
    //         setSelectedData([]);
    //     }
    // };

    const optionsForSelect = combinedOptions.map((item) => ({
        value: item.id,
        label: item.name,
        type: item.type,
        data: item.data
        }));

        const handleSelectChangeExamProfile= (selectedOption) => {
        setSelectedOption(selectedOption);

        if (selectedOption) {
            let analytes = [];
            const seenAnalytes = new Set();

            selectedOption.data.forEach((exam) => {
            if (exam.listAnalytes) {
                const nim = input_nim;
                exam.listAnalytes.forEach((a) => {
                if (a.result !== null && a.result !== undefined && !seenAnalytes.has(a.id_analyte)) {
                    analytes.push({ ...a, nim });
                    seenAnalytes.add(a.id_analyte);
                }
                });
            }
            });

            setSelectedData(analytes);
        } else {
            setSelectedData([]);
        }
        };

    
    return {
        
        viewData, workOrderPrintResultCaptureView, reload, items, activeIndex, setActiveIndex,

        downloadSheetResults, profilesHistories, headerStyle, cellStyle, validateData, input_nim,

        showPassword, input_password, handleInputChange, toggleShowPassword, loadingForm, loading,
        
        loadingNim, 
        
        openProfiles, toggleCollapse, profiles, idd, listaExamenes, toggleExamCollapse, openExams,setHistorialCollapse,
        historialCollapse, setSelectedStudy, selectedStudy, chartOptions, lista,

        selectedOption, selectedData, combinedOptions, loadChartData,

        chartDialogVisible, setChartDialogVisible, chartOptionsState, chartData,
        currentAnalyteId, setCurrentAnalyteId, currentPatientNim, setCurrentPatientNim,

        handleSelectChangeExamProfile, optionsForSelect,

        urlHelenLis

       

    }
}
